import { NgModule,CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { HttpModule } from './shared/http.module';
import { ApiService } from './Service/api.service';
import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
import { DatePipe } from '@angular/common';
import { NgCalendarModule  } from 'ionic2-calendar';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

registerLocaleData(localeIt)

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    NgCalendarModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    HttpModule.forRoot({environment}),     
    ReactiveFormsModule,
    FormsModule, ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, 
              { provide: LocationStrategy, useClass: HashLocationStrategy},
              ApiService,
              DatePipe],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA],
})
export class AppModule {
 


}
